import * as generics from '#components/generics/js/styles.js'
import preventDefault from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import capture from '@mailobj-browser/front/js/events/options/capture.js'
import mouseUp from '@mailobj-browser/front/js/events/types/mouseUp.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import swap from '@mailobj-browser/front/js/tree/swap.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import globals from '#utilities/js/ea/globals.js'
import href from '#utilities/js/ea/href.js'
import skin from '#utilities/js/ea/skin.js'
import { app, smartphone, tablet } from '#utilities/js/ea/skins.js'

const skins = [app, smartphone, tablet]
const id = 'div_RT_postit'

const onClick = object(listener, {
  capture,
  type: mouseUp,
  hooks: array([
    preventDefault
  ]),
  task: async (
    button,
    event
  ) => {
    const { ownerDocument } = button
    const { clientX, clientY } = event
    let url
    const floatingPostit = getComputedStyle(button).getPropertyValue('--ea_auth_mains_create_floating_postit')

    if (skins.includes(skin) || floatingPostit === 'false') {
      url = href('auth/postit', {
        list: 1
      })
    } else {
      url = href('auth/postit', {
        create: 1,
        posX: clientX,
        posY: clientY
      })
    }

    globals.ea_link(url, floatingPostit === 'true' ? id : '', null)

    const containerNewPostit = one(`#${id}`, ownerDocument)
    const aside = one(`.${generics.elements.aside_postits}`, ownerDocument)

    await swap(containerNewPostit, aside)
  }
})

export default button => {
  onClick.listen(button)
}